export default [
	{value: 'NORMAL', name: '일반과세자'},
	{value: 'SIMPLE', name: '간이과세자'},
	{value: 'VAT_FREE', name: '부가세 면세사업'},
	{value: 'CORPORATION', name: '법인사업자'},
	{value: 'FREE_CORPORATION', name: '면세법인사업자'},
	{value: 'ETC', name: '기타'}
];
